import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemProjectSelectRoute: InvariantJiraRoute = {
	name: 'global-settings-system-project-select',
	path: '/secure/project/SelectProject(\\w*)([!%]?[\\w]*).jspa',
};
